import { CommonAlertService } from './../../services/common-alert.service';
import { filter } from 'rxjs/operators';
import { MasterService } from './../../home/services/master.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductsComponent } from '../../home/more/products/products.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgForm, Form } from '@angular/forms';
import { BASE_URL } from '../../config/config';


@Component({
  selector: 'app-product-modal',
  templateUrl: './product-modal.component.html',
  styleUrls: ['./product-modal.component.scss']
})
export class ProductModalComponent implements OnInit {

  public bodypartsData: any;
  public implantsData: any;
  public implantsSelect: any;
  public productCategoryData: any;
  public productCategorySelect: any;
  public productsSelect: any;
  public editOb: any;
  public editData: any;
  public ImgName: any;
  public name: any;
  // tslint:disable-next-line:variable-name
  public body_part_id: any;
  // tslint:disable-next-line:variable-name
  public implant_id: any;
  successMsg: any;
  public model = {
    product_category_id: '',
    implant_id: '',
    body_part_id: ''
  } ;
  public user = {
    name : '',
  };
  public submitted = false;
  public editPermission = false;
  constructor(public dialogRef: MatDialogRef<ProductModalComponent>,
              public masterService: MasterService, @Inject(MAT_DIALOG_DATA) data, public commonAlertService: CommonAlertService) {
    if (data) {
      this.editOb = data.edit;
    }
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.editPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
       // tslint:disable-next-line:triple-equals
      if (roles['more.products.edit'] == 1) {
        this.editPermission = true;
      }
    }
    if (this.editOb) {
      const id = this.editOb.editID;
      // tslint:disable-next-line:variable-name
      const enc_id = this.editOb.encryId;

      this.masterService.getRecordById(id, enc_id, '/products/get_data').subscribe(res => {
        // @ts-ignore
        this.editData = res.data.product;
         if (this.editData.image_name) {
           this.ImgName = BASE_URL.APP_URL +  this.editData.image_name;
         } else {
           this.ImgName = BASE_URL.APP_URL +  'noImage.png';
         } 
        this.model.body_part_id = this.editData.body_part_id;
        // @ts-ignore
        this.bodypartsData = res.data.body_parts;
        this.model.implant_id = this.editData.implant_id;
        // @ts-ignore
        this.implantsData = res.data.implants;
        this.implantsSelect = this.implantsData;
        this.model.product_category_id = this.editData.product_category_id;
        // @ts-ignore
        this.productCategoryData = res.data.product_categories;
        this.productCategorySelect = this.productCategoryData;
        // this.warehouse_id                = 1;
      });
    } else {
      this.masterService.getData('/body_parts/get').subscribe(res => {
        // @ts-ignore
        this.bodypartsData = res.data;
      });

      this.masterService.getData('/implants/get').subscribe(res => {
        // @ts-ignore
        this.implantsData = res.data;
      });

      this.masterService.getData('/product_categories/get').subscribe(res => {
        // @ts-ignore
        this.productCategoryData = res.data;
      });
    }
  }

  bodypartChange(args) {
    this.model.body_part_id = args.target.value;
    // tslint:disable-next-line:triple-equals
    this.implantsSelect = this.implantsData.filter(result => result.body_part_id == this.model.body_part_id);
  }

  implantChange(args) {
    this.model.implant_id = args.target.value;
    // tslint:disable-next-line:triple-equals
    this.productCategorySelect = this.productCategoryData.filter(result => result.implant_id == this.model.implant_id);
  }

  submitForm(data) {
    if (this.editData) {
      // tslint:disable-next-line:variable-name max-line-length
      const form_data = Object.assign(data, { id: this.editOb.editID, enc_id: this.editOb.encryId, token: localStorage.getItem('token')});
      this.successMsg = 'Record Updated Successfully';
      this.masterService.addEditRecord(form_data, '/products/update').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        }
      });

    } else {
      // tslint:disable-next-line:variable-name
      const form_data = Object.assign(data, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Added Successfully';
      this.masterService.addEditRecord(form_data, '/products/store').subscribe(res => {
      // @ts-ignore
      if (res.success) {
          this.commonAlertService.showSuccessMsg({message: this.successMsg});
        }
      });
    }
    this.close();
  }

  close() {
    this.dialogRef.close();
  }

}
